import React from 'react';
import { Navigate } from 'react-router-dom';
import { isValidToken } from '../utils/loginfunctions';

const PrivateRoute = ({ children }) => {
    const accessToken = sessionStorage.getItem('access_token');
    if (isValidToken(accessToken)) {
        return children;
    } else {
        return <Navigate to="/" />;
    }
};

export default PrivateRoute;